export const APP_ROOT = '/';

export const FORM_CAPTURE_PAGE = '/f/:virtualPhoneNumber';
export const PRODUCT_LANDING_PAGE = '/p/:virtualPhoneNumber';
export const LOGIN_PAGE = '/login';
export const SIGNUP_PAGE = '/signup';

export const SNAPFLOW_PAGE = '/s/:virtualPhoneNumber';
export const MY_BOOKINGS_PAGE = '/m/:virtualPhoneNumber';

export const QR_SCANNER_PAGE = '/in/:virtualPhoneNumber';
export const QR_SCANNER_ITEM_PAGE = '/in/:virtualPhoneNumber/:userId';

export const RSVP_PAGE = '/e/:virtualPhoneNumber';

export const BOOKING_PAGE = '/b/:virtualPhoneNumber';
export const BOOKING_SERVICE_PAGE = '/b/:virtualPhoneNumber/:serviceId';
export const NFT_ITEM = '/nftcard';
export const NFT_MIA = '/nftmia';
